import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import DoneIcon from '@material-ui/icons/Done';
import { removeAlert } from '../../api/alertsAPI';

const useStyles = makeStyles(() => ({
  fullWidth: {
    width: '100%'
  },
  closeButton: {
    float: 'right',
    marginLeft: '15px',
  },
  acceptButton: {
    float: 'right',
  },
}));

export default function WelcomeAlert({...props}) {
  const classes = useStyles();
  const { removeAlert: handleRemoveAlert, alert } = props;

  const handleAccept = () => {
    try {
      removeAlert(alert.id);
      handleRemoveAlert();
    } catch (e) {
      console.error(e.message);
    }
  }
  return (
    <MenuItem>
      <Typography 
        className={classes.fullWidth}
        component="p"
        noWrap
      >
        Welcome to the Gospel Hall Directory!
        <IconButton 
          className={classes.acceptButton}
          color="primary"
          size="small"
          aria-label="accept"
          onClick={handleAccept}
        >
          <DoneIcon />
        </IconButton>
      </Typography>
    </MenuItem>
  )
}